/* eslint-disable no-unused-vars */

/**
 * ws 订阅类型
 */
export enum NORMAL_SUBSCRIBE_MAP {
  KLINE = 'kline',
  TRADE = 'trade',
  DEPTH = 'depth',
  PRICE = 'price',
  COMMON = 'common',
  INNOVATE = 'innovate',
  P2P_MAIN = 'p2p',
  has = "has",
  get = "get"
}

/**
 * ws 请求类型
 */
export enum NORMAL_REQUEST_MAP {
  // 获取全量交易对价格涨跌幅信息
  TICKERS = 'tickers',
}

export const WORKER_MSG_TOPIC = new Map([
  ['SUBSCRIBE', 1],
  ['UNSUBSCRIBE', 2],
  ['REQUEST', 3],
]);

export const supportTextEncoder = typeof TextEncoder === 'function';

export interface WsData<T = any> {
  code: number;
  data: T;
  symbol: number;
  subscribe?: string;
  request?: string;
  [key: string]: any;
}
